<template>    
    <v-dialog v-model="feed_window" :width="$store.state.textFormatting.dialog.width">
        <template v-slot:activator="{ on }">
            <v-icon v-if="type=='feedback'" v-on="on" @click="prepForm()"> report_problem </v-icon>
            <v-btn v-if="type=='question'" v-on="on" @click="prepForm()" color="success"> ASK A QUESTION </v-btn>
        </template>
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title :style="$store.state.textFormatting.main">
                <span v-if="type=='feedback'"> Report a bug / give feedback </span>
                <span v-if="type=='question'"> Ask us a question </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-layout>
                        <v-flex xs12 md6>
                            <v-switch v-model="anony">
                                <template v-slot:label>
                                    <div :style="$store.state.textFormatting.main">Submit Anonymously</div>
                                </template>
                            </v-switch>
                        </v-flex>
                        <v-flex xs12 md6 v-if="!anony">
                            <v-text-field v-model="userName" label="Edit Submission Name:" :style="$store.state.textFormatting.main"> </v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout>
                            <v-flex xs12 md12>
                                <v-textarea v-if="type=='feedback'" v-model="feedbackText" label="Insert feedback here (please be as detailed as possible)" :rules="fbrules" required :style="$store.state.textFormatting.main"></v-textarea>
                                <v-textarea v-if="type=='question'" v-model="feedbackText" label="Insert question here (please be as detailed as possible)" :rules="qrules" required :style="$store.state.textFormatting.main"></v-textarea>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            
                            <v-flex xs12 md12 v-if="showmsg">
                                <v-card class="justify-right" :color="msgcol">
                                    <h3 :style="$store.state.textFormatting.main"> {{ msg }} </h3>
                                </v-card>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-btn @click="formValidate()" :disabled="!valid" color="success" :style="$store.state.textFormatting.main">SUBMIT</v-btn>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>           
        </v-card>
    </v-dialog>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';


export default {
    data() {
        return {
            feed_window: false,
            showmsg: false,
            msg: "",
            msgcol: "success",
            valid: true,
            anony: true,
            userName: false,
            feedbackText: "",
            fbrules: [ v => !!v || 'Feedback is required', v => (v && v.length > 1) || 'Feedback must be longer than 1 letter', v => /^[^"]*$/.test(v) || 'No double-quotes allowed'],
            qrules: [ v => !!v || 'Question is required', v => (v && v.length > 1) || 'Question must be longer than 1 letter', v => /^[^"]*$/.test(v) || 'No double-quotes allowed'],
            type: 'feedback',
        }
    },
    beforeMount () {
        if (this.$attrs.type) {
            this.type = this.$attrs.type;
        }

        try {
            if (this.$store.state.user != null) {
                this.userName = this.$store.state.user.username;
                this.org = this.$store.state.user.organisation;
            } else {
                this.$store.state.user={}
                this.$store.state.user.username="";
                location.reload()
            }
        } catch (err) {
            console.log(err)
            this.userName = null
            this.org = null
        }
    },
    methods: {
        submitFeedback: async function () {
            if (this.$store.state.signedIn) {
                var a;
                var orgUse;
                var usr;
                if (this.anony) {
                    a = 1;
                    orgUse = "ANON";
                    usr = "ANON";
                } else {
                    a = 0;
                    orgUse = this.org;
                    usr = this.userName;
                }
            } else {
                var a = 1;
                var orgUse = "UNSIGNED";
                var usr = "UNSIGNED";
            }

            //var d = new SimpleDateFormat("dd/MM/yyyy HH:ii").format(new Date());
            try { 
                var d = new Date().toISOString();            
                var fbQuery = `query submitFeedback {
                    submitFeedback ( 
                        anonymous: `+a+`,
                        organisation: "`+ orgUse + `",
                        username: "` + usr + `",
                        message: "` + this.feedbackText.replace(/(\r\n|\n|\r)/gm, ' // ') + `",
                        timestamp: "` + d + `",
                        page_used: "` + this.$route.fullPath + `"                    
                        )
                    }`;
                console.log(fbQuery);
                const response = await API.graphql(graphqlOperation(fbQuery));
                console.log(response);

                var fbemail = `mutation sendFeedback {
                    sendFeedback ( 
                        anonymous: `+a+`,
                        organisation: "`+ orgUse + `",
                        username: "` + usr + `",
                        message: "` + this.feedbackText.replace(/(\r\n|\n|\r)/gm, ' // ') + `",
                        timestamp: "` + d + `",
                        page_used: "` + this.$route.fullPath + `"                    
                        )
                        {
                            data
                            messageId
                            result
                        }
                    }`;
                console.log(fbemail);
                const emailResponse = await API.graphql(graphqlOperation(fbemail));
                console.log(emailResponse);

                if (!response.data.submitFeedback) {
                    this.msg = "Feedback submitted, thank you";
                    this.msgcol = "success";
                    this.showmsg = true;
                    this.feedbackText = "";

                } else {
                    this.msg = response.data.submitFeedback;
                    this.msgcol = "red";
                    this.showmsg = true;
                }
            } catch (err) {
                console.log(err);
                this.msg = "Error submitting feedback";
                this.msgcol = "red";
                this.showmsg = true;
            }

            
            this.$refs.form.resetValidation();
            

        },
        prepForm: async function () {
            try {
                this.userName = this.$store.state.user.username;
                this.org = this.$store.state.user.organisation;
            } catch (err) {
                this.userName = null
                this.org = null
            }
        },
        formValidate: async function () {
            this.showmsg = false;
            if(this.$refs.form.validate()) {
                if(this.feedbackText.length > 0) {
                    this.submitFeedback();
                } else {
                    this.msg = "Please enter a feedback message";
                    this.msgcol = "#f9fc4d";
                    this.showmsg = true;
                }
            }
        }
    }
}
</script>
